import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import "./ProductPage.css";
import { useSelector } from "react-redux";

function ProductPage() {
  let mensData = JSON.parse(localStorage.getItem("mensData")) || [];

  let cartData = JSON.parse(localStorage.getItem("cartData")) || [];

  const isAuth = useSelector((store) => store.isAuth.isAuth);

  const [filterValue, setFilterValue] = useState("");

  const [sort, setSort] = useState("");

  const handleCategory = (value) => {
    // console.log(value.target.defaultValue);
    setFilterValue(value.target.defaultValue);
  };

  const navigate = useNavigate();

  const handeleSort = (e) => {
    setSort(e.target.value);
  };

  if (sort === "asc") {
    mensData.sort((a, b) => a["price"] - b["price"]);
  } else if (sort === "desc") {
    mensData.sort((a, b) => b["price"] - a["price"]);
  } else if (sort === "cashback") {
    mensData.sort((a, b) => b["cashBack"] - a["cashBack"]);
  }

  const handleAddToCart = (el) => {
    if (isAuth === true) {
      cartData = [...cartData, el];
      //  console.log(cartData);
      localStorage.setItem("cartData", JSON.stringify(cartData));
      alert("Added to Cart");
      navigate("/products");
    } else {
      alert("Please Login First");
    }
  };

  return (
    <div className="productMain">
      <div className="sortFilter">
        <div>
          <h3>Sort:</h3>
          <select onChange={handeleSort}>
            <option value="">Best Match</option>
            <option value="asc">Price Low to High</option>
            <option value="desc">Price High to Low</option>
            <option value="cashback">Most Cashback</option>
          </select>
        </div>
        <div>
          <FormGroup onChange={handleCategory}>
            <h3>Filter:</h3>
            <FormControlLabel
              control={<Checkbox />}
              label="Pajamas"
              value="pajama"
            />
            <FormControlLabel
              control={<Checkbox />}
              label="Shirts"
              value="shirt"
            />
            <FormControlLabel
              control={<Checkbox />}
              label="T-Shirts"
              value="tShirt"
            />
            <FormControlLabel
              control={<Checkbox />}
              label="Hoodies"
              value="hoodie"
            />
            <FormControlLabel
              control={<Checkbox />}
              label="Jackets"
              value="jacket"
            />
            <FormControlLabel
              control={<Checkbox />}
              label="Briefs"
              value="brief"
            />
            <FormControlLabel
              control={<Checkbox />}
              label="Socks"
              value="socks"
            />
            <FormControlLabel control={<Checkbox />} label="Ties" value="tie" />
            <FormControlLabel
              control={<Checkbox />}
              label="Miscelleneous"
              value="misc"
            />
          </FormGroup>
        </div>
      </div>
      <div className="products">
        {mensData
          .filter((e) => e.type.includes(filterValue))
          .map((el, index) => (
            <div className="singleProduct" key={index}>
              <div>
                <img src={el.link} alt="" width="200px" />
              </div>
              <h3>{el.title}</h3>
              <div>
                <img
                  src="https://img.shop.com/Image/resources/images/onecart-icon.svg"
                  alt=""
                  width="12px"
                />
                <span>Sold by Belt Outlet</span>
                <h3>${el.price}</h3>
              </div>
              <div>
                <span>
                  + ${el.cashBack} / {el.percentCashBack}%
                </span>
                <img
                  src="https://img.shop.com/Image/resources/images/cashback-icon.svg"
                  alt=""
                  width="12px"
                />
                <span>Cashback</span>
              </div>
              <div>
                <button>See Details</button>
                <button onClick={() => handleAddToCart(el)}>Add To Cart</button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default ProductPage;
